import React from 'react';
import { ModalController } from '../../../components/Modal/ControlledModal';
import { Form, useChanges } from '../../../components/Form/Form';
import { TextField } from '../../../components/Form/TextField/TextField';
import { createContract, updateContract, ContractInfo } from '../../../model/contract';
import { handleError } from '../../../model/notification';
import { t } from '../../../locales/translate';
import { Checkbox } from '../../../components/Form/Checkbox/Checkbox';
import { Stack } from '../../../components/Stack/Stack';
import { Spacer } from '../../../components/Spacer/Spacer';

interface Props {
  controller: ModalController<ContractInfo>;
  updatingContractId?: string;
  onSuccess?: () => void;
}

export function ContractForm({ controller, updatingContractId, onSuccess }: Props): JSX.Element {
  const [, , model, setModel] = useChanges<ContractInfo>({
    ...controller.model,
  });

  async function handleSubmit(): Promise<void> {
    try {
      updatingContractId ? await updateContract(updatingContractId, model) : await createContract(model);
      onSuccess?.();
      controller.close();
    } catch (e) {
      handleError(e);
    }
  }

  return (
    <Form model={model} onInput={setModel}>
      {(form) => {
        controller.configure({
          canSubmit: form.valid,
          onSubmit: handleSubmit,
        });
        return (
          <Stack>
            <TextField name="name" label={t.general.name} required />
            <Spacer size="none" />
            <Checkbox name="archived" label={t.general.archived} />
          </Stack>
        );
      }}
    </Form>
  );
}
